var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGithuboutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1115 114.292C88.5802 114.292 114.091 88.7806 114.091 57.3119C114.091 25.8429 88.5802 0.332268 57.1115 0.332268C25.6425 0.332268 0.131836 25.8429 0.131836 57.3119C0.131836 88.7806 25.6425 114.292 57.1115 114.292Z",
    fill: "#FCF9F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.407 97.1977V86.5824C70.5495 84.8188 70.305 83.0456 69.6891 81.3813C69.0737 79.7169 68.1011 78.199 66.8367 76.9289C78.7642 75.6343 91.2998 71.2326 91.2998 51.0379C91.2986 45.8736 89.2587 40.9075 85.6018 37.1674C87.3334 32.6495 87.2109 27.6556 85.2599 23.2232C85.2599 23.2232 80.7773 21.9287 70.407 28.6974C61.7005 26.3998 52.5234 26.3998 43.8167 28.6974C33.4464 21.9287 28.964 23.2232 28.964 23.2232C27.0129 27.6556 26.8905 32.6495 28.6221 37.1674C24.9379 40.9353 22.8957 45.9462 22.9241 51.1484C22.9241 71.1956 35.4596 75.5973 47.3872 77.0394C46.1377 78.297 45.1738 79.7967 44.5586 81.4411C43.9433 83.085 43.6906 84.8365 43.8167 86.5824V97.1977",
    fill: "#FCF9F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.407 97.1977V86.5824C70.5495 84.8188 70.305 83.0456 69.6891 81.3813C69.0737 79.7169 68.1011 78.199 66.8367 76.9289C78.7642 75.6343 91.2998 71.2326 91.2998 51.0379C91.2986 45.8736 89.2587 40.9075 85.6018 37.1674C87.3334 32.6495 87.2109 27.6556 85.2599 23.2232C85.2599 23.2232 80.7773 21.9287 70.407 28.6974C61.7005 26.3998 52.5234 26.3998 43.8167 28.6974C33.4464 21.9287 28.964 23.2232 28.964 23.2232C27.0129 27.6556 26.8905 32.6495 28.6221 37.1674C24.9379 40.9353 22.8957 45.9462 22.9241 51.1484C22.9241 71.1956 35.4596 75.5973 47.3872 77.0394C46.1377 78.297 45.1738 79.7967 44.5586 81.4411C43.9433 83.085 43.6906 84.8365 43.8167 86.5824V97.1977",
    stroke: "#4B5E76",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8161 89.8006C32.4202 93.4 22.9236 89.8006 17.2256 78.7044L43.8161 89.8006Z",
    fill: "#FCF9F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8161 89.8006C32.4202 93.4 22.9236 89.8006 17.2256 78.7044",
    stroke: "#4B5E76",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGithuboutline);
export default __webpack_public_path__ + "static/media/🦆 icon _github outline_.bd473468cffdc780261a7665e8a0b1c3.svg";
export { ForwardRef as ReactComponent };